import { Dispatch } from '@reduxjs/toolkit';
import { Initializer } from '@wajeez-web/core/types';
import { useCommonSelector } from '@wajeez-web/stores/common';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

export const initialize = async (
  dispatch: Dispatch,
  initializers: Initializer[]
) => {
  const orders = initializers
    .map((initializer) => initializer.order)
    .filter((v, i, a) => a.indexOf(v) === i)
    .sort((a, b) => a - b);

  for (let i = 0; i < orders.length; i++) {
    const order = orders[i];
    // run all initializers at the same order in parallels
    const initializersAtOrder = initializers.filter(
      (initializer) => initializer.order === order
    );
    await Promise.all(
      initializersAtOrder.map((initializer) => initializer.execute(dispatch))
    );
  }
};
// compare all the element of the array
export const compareArray = (a: any[] | undefined, b: any[] | undefined) => {
  if (a === b) {
    return true;
  }
  if (a === undefined || b === undefined) {
    return false;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
};

export const useRouting = (
  initializers: Initializer[],
  isAuthenticated = true
) => {
  const dispatch = useDispatch();
  const oldInitializers = useRef<Initializer[]>([]);

  useEffect(() => {
    if (isAuthenticated) {
      for (let i = 0; i < initializers.length; i++) {
        const initializer = initializers[i];
        const oldInitializer = oldInitializers.current.find(
          (x) => x.name === initializer.name
        );
        if (oldInitializer) {
          if (
            !compareArray(oldInitializer.dependencies, initializer.dependencies)
          ) {
            initialize(dispatch, [initializer]);

            // replace old initializer with new one
            oldInitializers.current = oldInitializers.current.map((x) =>
              x.name === initializer.name ? initializer : x
            );
          }
        } else {
          initialize(dispatch, [initializer]);
          oldInitializers.current.push(initializer);
        }
      }
    }
  }, [
    isAuthenticated,
    dispatch,
    compareArray(
      initializers.map((s) => s.dependencies ?? []).flat(),
      oldInitializers.current.map((s) => s.dependencies ?? []).flat()
    )
      ? true
      : random(),
  ]);

  const { endpoints, routes } = useCommonSelector((s) => s.navigation);

  return { endpoints, routes };
};

// get random number
const random = () => Math.random();
